import React, { memo } from 'react';
import { doctube_playlist_details_static_image } from '../../../../Common/assets.common';
import { openNewTab } from '../../../../common/common';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { FaPlay, RiPlayListAddFill } from '../../../../components/icons';
import './css/doctubePlaylistCard.scss';
import doctubePlaylistStaticImage from '../../../../assets/images/doctubePlaylistStaticImage.jpg';

function DoctubePlaylistCard({ data }) {
  return (
    <div className="cardBox playListCardV2">
      <div className="cardBoxIn rounded-3 overflow-hidden">
        <div
          className="w-100 overflow-hidden cardPicArea"
          onClick={() =>
            openNewTab(data?.deeplink, () => {
              window.location.href = data?.deeplink;
            })
          }
        >
          <LazyImage
            src={data?.video_thumbnail ?? doctubePlaylistStaticImage}
            // src={data?.video_thumbnail ?? doctube_playlist_details_static_image}
            className="object-fit-cover w-100 h-100 float-start"
            extraClass="w-100 h-100 position-relative"
            // fallback_image={doctube_playlist_details_static_image}
            fallback_image={doctubePlaylistStaticImage}
          />
          <div className="overlay cursorPointer d-flex align-items-center justify-content-center transition">
            <div className="rounded-circle playListCardV2Circle text-center position-relative bg-black bg-opacity-75">
              {data?.total_video && (
                <span className="playListCardV2Circle_in w-100 h-100 d-flex align-items-center justify-content-center flex-column">
                  <RiPlayListAddFill customClass={'text-white fs-2'} />
                  <span className="fs-16 text-white mt-2">{data?.total_video}</span>
                </span>
              )}
              <span className="playListCardV2Circle_hvr text-black fs-16 position-absolute top-50 start-0 translate-middle-y z-2 w-100">
                <FaPlay
                  customClass={
                    'text-black display-1 position-absolute top-50 start-50 translate-middle fs-30'
                  }
                />
                {/* <span className="fs-4 text-black mt-2">Play Now</span> */}
              </span>
            </div>
          </div>
          {/* <span className="cardTimer rounded-pill text-white fs-4 position-absolute bg-black bg-opacity-75 py-1 px-3 z-2">20:25</span> */}
        </div>
      </div>
    </div>
  );
}

export default memo(DoctubePlaylistCard);
